export const conditionalLogicFragment = `
  actionType
  logicType
  rules { fieldId operator value }
`;

export const formConfirmationFragment = `
  conditionalLogic { ${conditionalLogicFragment} }
  id isActive isDefault message name pageId queryString type url
  page { node { link } }
`;

export const submitButtonFragment = `
  conditionalLogic { ${conditionalLogicFragment} }
  imageUrl text type
`;

export const captchaFieldFragment = `
  ... on CaptchaField {
    captchaLanguage captchaTheme captchaType conditionalLogic { ${conditionalLogicFragment} }
    cssClass description descriptionPlacement errorMessage label
    simpleCaptchaBackgroundColor simpleCaptchaFontColor simpleCaptchaSize
  }
`;

export const checkboxFieldFragment = `
  ... on CheckboxField {
    adminLabel canPrepopulate checkboxValues { inputId value }
    choices { ... on CheckboxFieldChoice { isSelected text value } }
    conditionalLogic { ${conditionalLogicFragment} } cssClass description descriptionPlacement
    errorMessage hasChoiceValue hasSelectAll inputs { ... on CheckboxInputProperty { id name label } }
    inputName isRequired label
  }
`;

export const radioFieldFragment = `
  ... on RadioField {
    adminLabel canPrepopulate choices { ... on RadioFieldChoice { isOtherChoice isSelected text value } }
    conditionalLogic { ${conditionalLogicFragment} } cssClass description descriptionPlacement
    hasChoiceValue hasOtherChoice errorMessage inputName isRequired label shouldAllowDuplicates value
  }
`;

export const dateFieldFragment = `
  ... on DateField {
    adminLabel calendarIconType calendarIconUrl canPrepopulate conditionalLogic { ${conditionalLogicFragment} }
    cssClass dateFormat dateType defaultValue description descriptionPlacement errorMessage
    inputName inputs { ... on DateInputProperty { id autocompleteAttribute customLabel defaultValue label placeholder } }
    isRequired label placeholder shouldAllowDuplicates subLabelPlacement value
  }
`;

export const emailFieldFragment = `
  ... on EmailField {
    adminLabel canPrepopulate conditionalLogic { ${conditionalLogicFragment} } cssClass description
    descriptionPlacement errorMessage hasAutocomplete hasEmailConfirmation inputName
    inputs { ... on EmailInputProperty { id name autocompleteAttribute customLabel defaultValue label placeholder } }
    isRequired label labelPlacement placeholder shouldAllowDuplicates size subLabelPlacement value
  }
`;

export const hiddenFieldFragment = `
  ... on HiddenField { canPrepopulate defaultValue inputName label value }
`;

export const numberFieldFragment = `
  ... on NumberField {
    adminLabel autocompleteAttribute calculationFormula calculationRounding canPrepopulate
    conditionalLogic { ${conditionalLogicFragment} } cssClass defaultValue description descriptionPlacement
    errorMessage hasAutocomplete inputName isCalculation isRequired label numberFormat
    placeholder rangeMax rangeMin shouldAllowDuplicates size value
  }
`;

export const phoneFieldFragment = `
  ... on PhoneField {
    adminLabel autocompleteAttribute canPrepopulate conditionalLogic { ${conditionalLogicFragment} }
    cssClass defaultValue description descriptionPlacement errorMessage hasAutocomplete inputName
    isRequired label labelPlacement phoneFormat placeholder shouldAllowDuplicates size value
  }
`;

export const htmlFieldFragment = `
  ... on HtmlField {
    conditionalLogic { ${conditionalLogicFragment} } content cssClass hasMargins label
  }
`;

export const selectFieldFragment = `
  ... on SelectField {
    adminLabel autocompleteAttribute canPrepopulate choices { ... on SelectFieldChoice { isSelected text value } }
    conditionalLogic { ${conditionalLogicFragment} } cssClass defaultValue description descriptionPlacement
    errorMessage hasAutocomplete hasChoiceValue hasEnhancedUI inputName isRequired label
    placeholder shouldAllowDuplicates size value
  }
`;

export const multiSelectFieldFragment = `
  ... on MultiSelectField {
    adminLabel canPrepopulate choices { ... on MultiSelectFieldChoice { isSelected text value } }
    conditionalLogic { ${conditionalLogicFragment} } cssClass description descriptionPlacement
    hasChoiceValue hasEnhancedUI errorMessage inputName isRequired label size values
  }
`;

export const textareaFieldFragment = `
  ... on TextAreaField {
    adminLabel canPrepopulate conditionalLogic { ${conditionalLogicFragment} } cssClass defaultValue
    description descriptionPlacement errorMessage inputName isRequired label labelPlacement
    maxLength shouldAllowDuplicates placeholder size hasRichTextEditor value
  }
`;

export const textFieldFragment = `
  ... on TextField {
    adminLabel autocompleteAttribute canPrepopulate conditionalLogic { ${conditionalLogicFragment} }
    cssClass defaultValue description descriptionPlacement errorMessage hasAutocomplete
    inputMaskValue inputName isPasswordInput isRequired label labelPlacement layoutGridColumnSpan
    maxLength placeholder shouldAllowDuplicates size value
  }
`;

export const sectionFieldFragment = `
  ... on SectionField {
    cssClass databaseId label type description displayOnly visibility
    layoutGridColumnSpan layoutSpacerGridColumnSpan conditionalLogic { ${conditionalLogicFragment} }
  }
`;

export const fileuploadFieldFragment = `
  ... on FileUploadField {
    adminLabel conditionalLogic { ${conditionalLogicFragment} } cssClass description descriptionPlacement
    errorMessage isRequired label labelPlacement value allowedExtensions canAcceptMultipleFiles
    inputType maxFileSize maxFiles type
  }
`;

export const nameFieldFragment = `
  ... on NameField {
    adminLabel canPrepopulate conditionalLogic { ${conditionalLogicFragment} } cssClass description
    descriptionPlacement errorMessage hasAutocomplete inputs {
      ... on NameInputProperty { id name autocompleteAttribute customLabel defaultValue label placeholder isHidden key choices { text value isSelected } }
    }
    isRequired label subLabelPlacement value
  }
`;

export const consentFieldFragment = `
  ... on ConsentField {
    conditionalLogic { ${conditionalLogicFragment} } adminLabel checkboxLabel consentValue cssClass
    description descriptionPlacement errorMessage isRequired inputType label labelPlacement value type visibility
  }
`;
